import './App.css';
import Header from './Components/Header';
import Main from './Components/Main';
import Footer from './Components/Footer';

function App() {
  return (
    <>
      <Header />
      <Main/>
      <Footer/>
    </>
  );
}

export default App;
